import React, { useContext, useEffect, useState } from "react";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectExpertType({
  expert_id,
  type,
  backupData,
  setBackupData,
}) {
  const [exType, setExType] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (type) {
      setExType(type);
    }
  }, [type]);

  const handleTypeChange = (e) => {
    setReturnError(false);
    setLoading(true);
    setExType(e.target.value);
    const url = `${API_URL}update-profile-type`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertID: expert_id, expertType: e.target.value }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.cons_exp = e.target.value;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      <select
        className="prjdetails-select-con no-select"
        value={exType}
        onChange={handleTypeChange}
        style={{ marginRight: "20px" }}
      >
        <option value="consultant">Consultant</option>
        <option value="expert">Expert</option>
        <option value="int">Interim</option>
      </select>
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "100px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "100px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "100px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
